const state = {
    selectedContract:null,
    allContractRes:null,
    allCrsEnums:null,



};

const getters = {
    GET_SELECTED_CONTRACT: (state) => {
        return state.selectedContract;
    },
    GET_ALL_CONTRACT_RES: (state) => {
        return state.allContractRes;
    },
    GET_ALL_CRS_ENUMS: (state) => {
        return state.allCrsEnums;
    },


   GET_CABIN_TYPE:(state)=>{

    if(state.allCrsEnums)
       return state.allCrsEnums.CabinType
     },
   GET_TTL_UNITS:(state)=>{
       if(state.allCrsEnums)
       return state.allCrsEnums.TtlUnits
   }  ,
   GET_FARE_TYPE:(state)=>{
       if(state.allCrsEnums)
       return state.allCrsEnums.FareType
   },
     GET_AIRCRAFT_TYPE:(state)=>{
         if(state.allCrsEnums)
         return state.allCrsEnums.AircraftType
},

GET_CRS_BOOKING_STATUS:(state)=>{
    if(state.allCrsEnums)
    return  state.allCrsEnums.CRSBookingStatus
}
  
     







};
const actions = {

    CLEAR_CONTRACT_STORE: ({ commit }) => {
        commit('clearStore');
    },

    SET_SELECTED_CONTRACT: ({ commit }, contract) => {
        commit('saveSelContract', contract);
    },
    SET_ALL_CONTRACT_RES: ({ commit }, res) => {
        commit('saveContractRes', res);
    },
    SET_ALL_CRS_ENUMS: ({ commit }, enums) => {
        commit('saveAllCrsEnumRes', enums);
    },
};

const mutations = {
    clearStore: (state) => {
        state.selectedContract = null;
        state.allContractRes = null;
        state.allCrsEnums=null
    },
    saveSelContract: (state, contract) => {
        state.selectedContract = contract;
    },
    saveContractRes: (state, res) => {
        state.allContractRes = res;
    },
    saveAllCrsEnumRes: (state, enums) => {
        state.allCrsEnums = enums;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};